import { Plugin } from 'prosemirror-state';
import './index.css';
export const BaseStyles = (builder) => {
    builder.addPlugin(() => new Plugin({
        props: {
            attributes: {
                class: 'yfm-editor',
            },
        },
    }));
};
